module.exports = __webpack_public_path__ + "media/src/assets/img/elements/homepod-e317263497178bc42064efeb9119d85c.png";